export { default } from './StarCircle'
